import React from 'react';
import { Link } from 'react-router-dom';
import { Crumb } from '../seo/jsonLd';

// 12px eyebrow type would give a 12px target, so the padding is the target: 24px
// under a mouse, 44px under a thumb. Same coarse-pointer rule as the footer.
const LINK_CLASS =
  'inline-flex min-h-[24px] items-center py-1.5 text-gray-400 transition-colors duration-150 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 [@media(pointer:coarse)]:min-h-[44px] [@media(pointer:coarse)]:py-3';

interface BreadcrumbProps {
  crumbs: Crumb[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ crumbs, className = '' }) => (
  <nav aria-label="Breadcrumb" className={className}>
    <ol className="flex flex-wrap items-center gap-x-2 font-mono text-eyebrow uppercase">
      {crumbs.map((crumb, index) => (
        <li key={crumb.name} className="flex items-center gap-x-2">
          {index > 0 && (
            <span aria-hidden="true" className="text-gray-400">
              /
            </span>
          )}
          {crumb.path ? (
            <Link to={crumb.path} className={LINK_CLASS}>
              {crumb.name}
            </Link>
          ) : (
            <span aria-current="page" className="py-1.5 text-gray-300">
              {crumb.name}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumb;
